<template>
  <el-row class="layout-page">
    <el-col
      :span="amisEditor.visible ? 16 : 24"
      class="layout-pane"
    >
      <el-row class="container">
        <!--头部内容-->
        <el-col
          :span="24"
          class="header"
        >
          <el-col
            :class="['text-omit', 'logo', !isCollapse ? 'logo-collapse-width' : 'logo-width']"
          >
            <img
              :src="logo"
              alt=""
            >
            {{ title }}
            <div
              v-show="!isProduct && apiBranch.length > 0"
              class="api-branch"
              v-text="apiBranch"
            />
          </el-col>
          <el-col :span="10" style="display: flex; height: 100%; align-items: center;">
            <div
              class="tools"
              @click.prevent="collapse"
            >
              <i class="fa fa-align-justify" />
            </div>
            <el-breadcrumb
              separator-class="el-icon-arrow-right"
              separator="/"
              class="breadcrumb-inner"
            >
              <el-breadcrumb-item
                v-for="(item, index) in $route.matched"
                :key="item.path"
              >
                <template v-if="index !== 0">
                  <router-link :to="item.path">{{ item.meta.label }}</router-link>
                </template>
                <template v-else>
                  {{ item.meta.label }}
                </template>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col
            :span="6"
            class="userinfo"
            style="min-width: 100px;"
          >
            <el-menu
              class="navbar"
              mode="horizontal"
            >
              <div
                class="user-profile-container"
                trigger="click"
              >
                <div class="user-profile-content">
                  <div class="menu-icons">
                    <!-- 暂时隐藏 -->
                    <!-- <span class="menu-icon"><i class="el-icon-message icon"></i></span> -->
                  </div>
                  <el-dropdown>
                    <div
                      v-show="user.name"
                      class="user-profile-body"
                      style="min-width: 100px;"
                    >
                      <img
                        class="user-avatar"
                        :src="
                          user.avatar ||
                            'https://img.alicdn.com/tfs/TB1ONhloamWBuNjy1XaXXXCbXXa-200-200.png'
                        "
                      >
                      <span class="user-name">{{ user.name }}</span>
                    </div>
                    <el-dropdown-menu
                      slot="dropdown"
                      class="user-dropdown"
                    >
                      <el-dropdown-item>
                        <span
                          style="display:block;"
                          @click="logout"
                        >
                          退出账号
                        </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </el-menu>
          </el-col>
        </el-col>
        <el-col
          :span="24"
          class="main"
        >
          <div
            :class="['menu-box', isCollapse ? 'auto-width' : '']"
          >
            <component :is="menuScrollComponent">
              <el-menu
                :default-active="$route.path"
                :default-openeds="menuOpened"
                class="el-menu-vertical-demo"
                :collapse-transition="false"
                router
                :collapse="!isCollapse"
              >
                <template v-for="(item, index) in menu">
                  <el-submenu
                    v-if="item.children"
                    :key="index"
                    :index="item.path"
                  >
                    <template slot="title">
                      <i :class="item.meta.icon" />
                      <span
                        slot="title"
                        class="bolden"
                      >
                        {{ item.meta.label }}
                      </span>
                    </template>

                    <template v-for="child in item.children">
                      <el-menu-item
                        :key="child.path"
                        :index="item.path + '/' + child.path"
                      >
                        {{ child.meta.label }}
                      </el-menu-item>
                    </template>
                  </el-submenu>
                  <el-menu-item
                    v-else
                    :key="index"
                    :index="item.path"
                    disabled
                  >
                    <i :class="item.meta.icon" />
                    <span
                      slot="title"
                      class="bolden"
                    >
                      {{ item.meta.label }}
                    </span>
                  </el-menu-item>
                </template>
              </el-menu>
            </component>
          </div>

          <!--主内容-->
          <section
            ref="layout_content_box"
            :class="['content-container', { 'white-bg': $route.meta.whiteBg }]"
          >
            <div v-loading="loading" />
            <div
              v-if="!loading"
              class="grid-content bg-purple-light"
            >
              <div v-if="$route.meta.label !== '列表'">
                <el-col
                  v-if="!$route.meta.hiddenContentTitle"
                  :span="24"
                  class="breadcrumb-container"
                >
                  <Title :text="$route.meta.label" />
                </el-col>
              </div>
              <el-col
                :span="24"
                class="content-wrapper"
              >
                <transition
                  name="fade"
                  mode="out-in"
                >
                  <router-view :isCollapse="isCollapse" />
                </transition>
              </el-col>
            </div>
          </section>
        </el-col>
      </el-row>
    </el-col>
    <el-col
      :span="amisEditor.visible ? 8 : 0"
      class="layout-pane"
    >
      <amis-editor
        :id="amisEditor.id"
        :visible="amisEditor.visible"
        :json="amisEditor.json"
        :path="amisEditor.path"
        @visible="onAmisVisible"
        @change="onAmisChange"
      />
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { PUSH_AMIS_EDITOR, UPDATE_AMIS_EDITOR } from '@/store/mutation-types';
import QuRequest from '../core/QuRequest';
import { filterMenuRoute } from '../router/menuRoute';
import ScrollBox from '@/components/ScrollBox';
import ScrollMobile from '@/components/ScrollMobile';
import AmisEditor from '@/components/AmisEditor';
import Title from '@/components/Title';
import Logo from '@/assets/image/logo.png';
import { logoutBySSO } from '@/common/auth/';
import * as $cache from '@/common/cache';
// import ewxLoginSDK from '@qtt/ewx-login-sdk';

const quRequest = new QuRequest();
const MOBILE_MAX_SHORT_SIDE = 767;

export default {
  components: { ScrollBox, ScrollMobile, Title, AmisEditor },
  data() {
    return {
      logo: Logo,
      loading: true,
      isCollapse: true,
      title: quRequest.getProjectTitle(),
      perms: [],
      menu: [],
      menuOpened: [],
      disabled: true,
      isProduct: quRequest.isProduct(),
      branchMap: quRequest.getBranch(),
      apiBranch: '',
      amisEditorVisible: false,
      isMobileTerminal: false,
    };
  },
  computed: {
    ...mapState(['user', 'amisEditor']),
    menuScrollComponent() {
      return this.isMobileTerminal ? 'ScrollMobile' : 'ScrollBox';
    },
    docTitle() {
      const paths = [...(this.$route.matched || [])].reverse();
      const title = paths.reduce((t, v) => {
        // eslint-disable-next-line no-param-reassign
        t += `${(v.meta || {}).label || ''} - `;
        return t;
      }, '');
      return `${title.trim()} CRM`;
    },
  },
  watch: {
    $route: 'onRoute',
  },
  mounted() {
    this.updateTerminalType();
    window.addEventListener('resize', this.updateTerminalType);
    window.addEventListener('orientationchange', this.updateTerminalType);
    if (this.branchMap && this.branchMap['sales-crm']) {
      this.apiBranch = this.branchMap['sales-crm'];
    }
    // 更新 doc title
    document.title = this.docTitle || 'CRM';
    // 初始化
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTerminalType);
    window.removeEventListener('orientationchange', this.updateTerminalType);
  },
  methods: {
    ...mapActions(['getAuthUser', 'getAuthToken', 'syncUser', 'getSysUser']),
    updateTerminalType() {
      if (typeof window === 'undefined') return;

      const ua = navigator.userAgent || '';
      const screenWidth = window.screen.width || 0;
      const screenHeight = window.screen.height || 0;
      const shortSide = Math.min(screenWidth, screenHeight);
      const isTouchDevice = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
      const isMobileUA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua);
      const isTabletUA = /iPad|Tablet|PlayBook/i.test(ua);

      this.isMobileTerminal = isMobileUA ||
        (isTabletUA && isTouchDevice) ||
        (isTouchDevice && shortSide > 0 && shortSide <= MOBILE_MAX_SHORT_SIDE);
    },

    // 获取菜单权限
    async getPerms() {
      try {
        const data = await quRequest.send(
          quRequest.Apis.sales.user.permissions,
        );
        this.perms = (data || {}).data || {} || [];
        return this.perms;
      } catch (err) {
        this.$message.error(`获取权限失败，${err.message || '未知错误'}`);
      }
    },

    // 初始化
    async init() {
      this.loading = true;
      this.getAuthUser();
      this.getAuthToken();
      this.getSysUser();
      // this.syncUser().then(done => {
      //     if (done) {

      //     }

      // });

      this.getPerms().then((perm) => {
        this.$store.commit({
          type: 'SET_PERMS',
          data: perm,
        });
        this.resetMenus(this.perms);
        this.checkRoutePerm(this.$route);
      });
      this.loading = false;
    },

    // 重置菜单
    resetMenus(perms = []) {
      if (perms.length <= 0) {
        return this.$router.replace({ name: 'NoPermission' });
      }
      const menuRoutesFromServe = [...perms];

      const joinPathByDeep = function(route = [], index = 0) {
        const iRoute = route[index] || {};
        let { path = '' } = iRoute;

        if ((iRoute.children || []).length > 0) {
          path += `/${joinPathByDeep(iRoute.children, index)}`;
        }

        return path;
      };

      this.menu = filterMenuRoute(menuRoutesFromServe);
      this.menuOpened = this.menu.map((i) => i.path);

      if (this.$route.path === '/' || this.$route.name === 'NoPermission') {
        this.$router.replace({ path: joinPathByDeep(this.menu) });
      }
    },

    // 检查当前路由是否有权限
    checkRoutePerm(route = {}) {
      if ((route.meta || {}).isMenu && !this.perms.includes(route.name)) {
        this.$router.replace({ name: 'NoPermission' });
      }
    },

    // 退出登录
    logout() {
      this.$confirm('确认退出吗?', '提示', {}).then(() => {
        $cache.localClear($cache.AUTH);
        logoutBySSO();
        // localStorage.removeItem($cache.AUTH);

        // this.$router.push('/login');
        // ewxLoginSDK.logout({ isPerm: true }).then(res => {
        //     this.$router.push('/login');
        // });
      });
    },

    // 折叠导航栏
    collapse() {
      this.isCollapse = !this.isCollapse;
    },

    // 监听路由变化
    onRoute() {
      // 文档置顶
      // 注意：由于架构content绝对定位限制，所以不能通过 scrollBehavior 作window监听
      this.$nextTick(() => {
        this.$refs.layout_content_box.scrollTop = 0;
      });

      // 更新 doc title
      document.title = this.docTitle || 'CRM';
    },

    onAmisVisible(v) {
      !v && this.$store.commit(PUSH_AMIS_EDITOR);
    },

    onAmisChange(v) {
      this.$store.commit(UPDATE_AMIS_EDITOR, v);
    },
  },
};
</script>

<style lang="less">
.nprogress-container {
  position: fixed !important;
  width: 100%;
  height: 50px;
  z-index: 2048;
  pointer-events: none;
  display: inherit;

  #nprogress {
    @color: #004c32;

    .bar {
      background: @color;
    }
    .peg {
      box-shadow: 0 0 10px @color, 0 0 5px @color;
    }

    .spinner-icon {
      border-top-color: @color;
      border-left-color: @color;
    }
  }
}

.layout-page {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  max-width: 100%;

  .layout-pane {
    position: relative;
    height: 100%;
  }
}

.container {
  position: relative;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;

  .auto-width {
    width: 230px;
    flex-shrink: 0;
  }
  .menu-box {
    min-width: 65px;
    background: #fff;
    border-right: 1px solid #ebeef5;

    .el-menu {
      border-right: 0;
    }

    .el-submenu .el-menu-item {
      &.is-active {
        background-color: #f2f9ff !important;
        color: #2f9eff !important;
      }
    }

    .bolden {
      font-weight: bold;
    }
  }

  .fa-user-o {
    margin: 0px 5px;
  }

  .header {
    flex-shrink: 0;
    height: 80px;
    line-height: 80px;
    background: #fff;
    border-bottom: 1px solid#EBEEF5;
    color: #303133;
    position: relative;

    .api-branch {
      position: absolute;
      top: 0;
      right: 0;
      height: 18px;
      line-height: 18px;
      padding: 0 8px;
      text-align: center;
      background-color: red;
      font-size: 14px;
      color: #ffffff;
    }

    .userinfo {
      text-align: right;
      float: right;
      .select-language {
        width: 120px;
      }

      .user-profile-container {
        position: absolute;
        right: 20px;
        cursor: pointer;

        .user-profile-content {
          display: flex;
        }
        .menu-icons {
          display: flex;
          align-items: center;
          .menu-icon {
            padding: 0 12px;
            .icon {
              display: inline-block;
              font-size: 18px;
              text-align: center;
            }
          }
        }
        .user-profile-body {
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding-right: 14px;
        }
        .user-avatar {
          width: 36px;
          height: 36px;
          margin: 0 8px 0 12px;
          border-radius: 4px;
        }
        .user-name {
          color: rgba(0, 0, 0, 0.65);
        }

        .el-icon-caret-bottom {
          position: absolute;
          right: 0;
          top: 13px;
          font-size: 12px;
        }
      }

      .el-select {
        vertical-align: top;
        margin-left: 20px;
      }
    }
    .logo {
      //width:230px;
      height: 80px;
      font-size: 16px;
      padding-left: 20px;
      padding-right: 20px;
      border-color: #ebeef5;
      border-right-width: 1px;
      border-right-style: solid;
      position: relative;

      &.logo-collapse-width {
        img {
          margin: 25px 20px 0 -6px;
        }
      }

      img {
        width: 40px;
        float: left;
        margin: 25px 10px 10px 18px;
      }
      .txt {
        color: #fff;
      }
    }
    .logo-width {
      width: 230px;
    }
    .logo-collapse-width {
      width: 65px;
    }
    .tools {
      display: inline-block;
      padding: 0px 23px;
      width: 17px;
      height: 60px;
      font-size: 17px;
      line-height: 60px;
      cursor: pointer;
      i.fa-align-justify {
        line-height: 60px;
      }
    }
    .breadcrumb-inner {
      display: inline-block;
    }
  }
  .main {
    flex: 1;
    display: flex;
    // background: #324057;
    // position: absolute;
    // top: 80px;
    // bottom: 0px;
    overflow: hidden;
    aside {
      flex: 0 0 230px;
      width: 230px;
      .el-menu {
        height: 100%;
        overflow-y: auto;
      }
      .collapsed {
        width: 60px;
        .item {
          position: relative;
        }
        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
    }
    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
      .el-menu {
        width: 100% !important;
      }
    }
    .menu-expanded {
      flex: 0 0 230px;
      width: 230px;
      .el-menu {
        width: 100% !important;
      }
    }
    .content-container {
      flex: 1;
      width: 0;
      overflow: auto;
      box-sizing: border-box;
      padding: 40px;
      background: #f8fbfe;
      .breadcrumb-container {
        padding-bottom: 32px;
      }
      .content-wrapper {
        background: #f8fbfe;
        box-sizing: border-box;
      }

      &.white-bg {
        background: #fff;
        .content-wrapper {
          background: #fff;
        }
      }
    }
  }
}

/* 针对手机屏幕（宽度小于768px） */
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .layout-page{
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    overflow: auto;
    overflow-y: hidden;
  }

  .container {
    .main {
      flex: 1;
      display: flex;
      min-width: 1200px;
      overflow: auto;
    }
    .header {
      min-width: 1200px;
      height: 50px;
      line-height: 50px;

      .userinfo {
        height: 50px;
        line-height: 50px;

        .navbar {
          height: 50px;
          line-height: 50px;
        }

        .user-profile-container {
          height: 50px;
          line-height: 50px;

          .user-profile-content {
            height: 50px;
            align-items: center;
          }

          .menu-icons {
            height: 50px;
          }

          .user-profile-body {
            height: 50px;
            min-height: 50px;
            padding-right: 14px;
          }

          .user-avatar {
            width: 30px;
            height: 30px;
            margin: 0 8px 0 12px;
          }

          .el-icon-caret-bottom {
            top: 19px;
          }
        }
      }

      .breadcrumb-inner,
      .el-breadcrumb {
        line-height: 50px;
      }

      .logo {
      //width:230px;
        height: 50px;
        line-height: 50px;
        img {
          width: 30px;
          float: left;
          margin: 10px 10px 10px 18px;
        }
      }
      .tools {
        display: inline-block;
        padding: 0px 23px;
        width: 17px;
        height: 50px;
        font-size: 14px;
        line-height: 50px;
        i.fa-align-justify {
          line-height: 50px;
        }
      }
    }
  }
}
</style>
